import { StanModal } from '@/components';

interface PaymentModalsProps {
    showProductWarningModal: boolean;
    showDisconnectModal: boolean;
    disconnectLoading: boolean;
    onProductWarningPrimary: () => void;
    onProductWarningSecondary: () => void;
    onProductWarningClose: () => void;
    onDisconnectConfirm: () => void;
    onDisconnectClose: () => void;
}

export const PaymentModals = ({
    showProductWarningModal,
    showDisconnectModal,
    disconnectLoading,
    onProductWarningPrimary,
    onProductWarningSecondary,
    onProductWarningClose,
    onDisconnectConfirm,
    onDisconnectClose,
}: PaymentModalsProps) => (
    <>
        <StanModal
            id='stripe-product-warning-modal'
            isOpen={showProductWarningModal}
            title='Heads up!'
            size='sm'
            primaryActionLabel="Let's Make a Product!"
            secondaryActionLabel='Connect Anyway'
            onPrimaryAction={onProductWarningPrimary}
            onSecondaryAction={onProductWarningSecondary}
            onClose={onProductWarningClose}
        >
            <p className='text-caption-1-regular mx-auto max-w-sm text-center'>
                👋 Just a quick tip: It&apos;s best to create a product first before connecting a payment method. That
                way, you&apos;re ready to hit the ground running!
            </p>
        </StanModal>

        <StanModal
            id='delete-stripe-modal'
            isOpen={showDisconnectModal}
            title='Just Confirming!'
            size='sm'
            primaryActionLabel='Yes, disconnect Stripe'
            primaryActionLoading={disconnectLoading}
            onPrimaryAction={onDisconnectConfirm}
            onClose={onDisconnectClose}
        >
            <p className='text-body-1-regular'>Are you sure you want to disconnect Stripe?</p>
        </StanModal>
    </>
);
